module.exports = __webpack_public_path__ + "static/img/10.f0ce677.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/8/zh/10.png
// module id = bFQ+
// module chunks = 0